module.exports = __webpack_public_path__ + "img/corrupted_ancient_of_battle_small.9b3202cd.png";